import { create } from 'zustand';

/**
 * Threat Store - Pure State Management
 * Rule: NO API IN STORE - Only state mutations
 * API calls are handled by ThreatIntegration
 */
const useThreatStore = create((set) => ({
  // State
  threats: [],
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  loading: false,
  error: null,
  selectedThreat: null,
  isEditing: false,
  isCreating: false,
  isDetailDialogOpen: false,
  threatToView: null,
  lastUpdated: null,

  // Pure State Mutations - NO API CALLS
  setThreats: (threats) => set({
    threats,
    lastUpdated: new Date().toISOString()
  }),

  setPagination: (paginationData) => set({ paginationData }),

  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setColumnFilters: (columnFilters) => set({ columnFilters }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  clearError: () => set({ error: null }),

  // UI Actions
  startCreating: () => set({
    isCreating: true,
    isEditing: false,
    selectedThreat: null,
    error: null
  }),

  startEditing: (threat) => set({
    isEditing: true,
    isCreating: false,
    selectedThreat: threat,
    error: null
  }),

  cancelForm: () => set({
    isEditing: false,
    isCreating: false,
    selectedThreat: null,
    error: null
  }),

  setSelectedThreat: (threat) => set({
    selectedThreat: threat
  }),

  openDetailDialog: (threat) => set({
    isDetailDialogOpen: true,
    threatToView: threat,
    error: null
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    threatToView: null,
    error: null
  }),

  reset: () => set({
    threats: [],
    columnFilters: {},
    uniqueValues: {},
    paginationData: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
      hasNextPage: false,
      hasPreviousPage: false,
    },
    loading: false,
    error: null,
    selectedThreat: null,
    isEditing: false,
    isCreating: false,
    lastUpdated: null,
  }),
}));

export { useThreatStore };
